// Class: openfl.display.PNGEncoderOptions

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $hxEnums = require("./../../hxEnums_stub").default;

// Constructor

var PNGEncoderOptions = function(fastCompression) {
	if(fastCompression == null) {
		fastCompression = false;
	}
	this.fastCompression = fastCompression;
}

// Meta

PNGEncoderOptions.__name__ = "openfl.display.PNGEncoderOptions";
PNGEncoderOptions.__isInterface__ = false;
PNGEncoderOptions.prototype = {
	
};
PNGEncoderOptions.prototype.__class__ = PNGEncoderOptions.prototype.constructor = $hxClasses["openfl.display.PNGEncoderOptions"] = PNGEncoderOptions;

// Init



// Statics




// Export

exports.default = PNGEncoderOptions;